const seoData = {
  business: {
    name: "Comet Cleaners",

    url: "https://cometcleaners.ca",

    email: "cometcleaners5@gmail.com",

    phone: "",

    whatsapp: "",

    logo: "https://cometcleaners.ca/logo-bc.png",

    image: "https://cometcleaners.ca/og-image.png",

    address: {
      street: "15 Westney Rd N Unit 4A",
      city: "Ajax",
      province: "Ontario",
      postalCode: "L1T 1P5",
      country: "Canada",
    },

    serviceAreas: ["Ajax", "Pickering", "Whitby"],

    services: [
      "Dry Cleaning",
      "Laundry Service",
      "Wash And Fold",
      "Steam Pressing",
      "Alterations",
      "Pant Hemming",
      "Zipper Replacement",
      "Garment Repairs",
      "Wedding Dress Cleaning",
      "Wedding Dress Alterations",
      "Wedding Dress Preservation",
      "Shoe Cleaning",
      "Shoe Repair",
      "Sneaker Restoration",
      "Handbag Cleaning",
      "Handbag Restoration",
      "Custom T Shirt Printing",
      "Uniform Printing",
      "Corporate Branding",
      "Event Merchandise Printing",
      "Rug Cleaning",
      "Carpet Cleaning",
      "Comforter Cleaning",
      "Cushion Cleaning",
      "Curtain Cleaning",
      "Leather Cleaning",
      "Suede Cleaning",
      "Fur Cleaning",
      "Pickup And Delivery",
    ],
    serviceAreas: ["Ajax", "Pickering", "Whitby", "Oshawa", "Durham Region"],
  },

  pages: {
    home: {
      title:
        "Comet Cleaners | One Stop Care Centre in Ajax | Cleaning, Repairs & Printing in Ajax",

      description:
        "Comet Cleaners provides professional dry cleaning, laundry, alterations, shoe repair, custom printing, wedding dress care, handbag cleaning, rug cleaning, comforter cleaning, cushion cleaning and steam pressing services. Serving Ajax, Pickering, Whitby and Durham Region with pickup & delivery.",

      keywords:
        "Dry Cleaning Ajax, Laundry Service Ajax, Alterations Ajax, Pant Hemming Ajax, Wedding Dress Cleaning Ajax, Wedding Dress Alterations Ajax, Shoe Cleaning Ajax, Shoe Repair Ajax, Sneaker Cleaning Ajax, Handbag Cleaning Ajax, Rug Cleaning Ajax, Comforter Cleaning Ajax, Cushion Cleaning Ajax, Steam Pressing Ajax, Custom Printing Ajax, T Shirt Printing Ajax, Uniform Printing Ajax, Dry Cleaners Pickering, Dry Cleaners Whitby",

      path: "/",
    },

    about: {
      title: "About Comet Cleaners | One Stop Care Centre in Ajax",

      description:
        "Learn about Comet Cleaners, Ajax's trusted destination for cleaning, alterations, shoe repair, custom printing and specialty care services.",

      keywords:
        "About Comet Cleaners, Ajax Cleaning Services, Shoe Repair Ajax, Custom Printing Ajax",

      path: "/about",
    },

    services: {
      title:
        "Services | Cleaning, Alterations, Shoe Repair & Custom Printing Ajax",

      description:
        "Explore dry cleaning, laundry, alterations, shoe repair, wedding dress care, custom printing, rug cleaning, handbag cleaning and specialty care services.",

      keywords:
        "Dry Cleaning Ajax, Alterations Ajax, Shoe Repair Ajax, Custom Printing Ajax, Wedding Dress Cleaning Ajax, Rug Cleaning Ajax",

      path: "/services",
    },

    pricing: {
      title: "Pricing | Cleaning, Alterations & Specialty Care Services Ajax",

      description:
        "Transparent pricing for dry cleaning, alterations, shoe repair, custom printing, wedding dress care and specialty cleaning services.",

      keywords:
        "Dry Cleaning Prices Ajax, Alteration Prices Ajax, Shoe Repair Prices Ajax, Custom Printing Ajax",

      path: "/pricing",
    },

    contact: {
      title: "Contact Comet Cleaners | Ajax One Stop Care Centre",

      description:
        "Contact Comet Cleaners for dry cleaning, alterations, shoe repair, custom printing and specialty care services in Ajax, Ontario.",

      keywords:
        "Contact Comet Cleaners Ajax, Dry Cleaning Ajax, Alterations Ajax, Shoe Repair Ajax",

      path: "/contact",
    },
    privacy: {
      title: "Privacy Policy | Comet Cleaners",
      description: "Privacy Policy for Comet Cleaners.",
      path: "/privacy-policy",
    },

    terms: {
      title: "Terms & Conditions | Comet Cleaners",
      description: "Terms and Conditions for Comet Cleaners.",
      path: "/terms-conditions",
    },
  },
};

export default seoData;
